import React, { useEffect, useState } from 'react'
import './ExtensiveRange.css'
import { IoDiamondOutline } from "react-icons/io5";
import RightImg from '../../../images/img16.jpg'
import { useInView } from 'react-intersection-observer';


const ExtensiveRange = () => {

    const [isExtensiveRangeVisible, setIsExtensiveRangeVisible] = useState(false);

    const { ref: ExtensiveRangeRef, inView: ExtensiveRangeInView } = useInView({
        triggerOnce: true,  // Trigger animation once when the element comes into view
        threshold: 0.5,  // Trigger when 50% of the element is in view
    });

    useEffect(() => {
        if (ExtensiveRangeInView) {
            setIsExtensiveRangeVisible(true)
        }
    }, [ExtensiveRangeInView])

    return (
        <div className='ExtensiveRangeWrap' ref={ExtensiveRangeRef}>

            <div className={`ExtensiveRangeCont ${isExtensiveRangeVisible ? 'animate-slide-up' : ''}`}>

                <div className='ExtRangeLeftCont'>


                    {/* <IoDiamondOutline className='ExtRangeDiamond' /> */}


                    <div className='ExtRangeLeftHeadText'>Extensive Product Range</div>

                    <div className='ExtRangeLeftDescText'>
                    At Honour Auto, we understand that every vehicle is unique, and so are its needs. Whether you’re a weekend DIYer, a professional mechanic, or a car enthusiast, we provide a comprehensive selection of high-quality auto parts to keep your vehicle running smoothly. Our product range includes everything from essential replacement parts to performance upgrades, catering to vehicles of all makes and models.
                    </div>

                    {/* <div className='ExtRangeLeftQualityCont'>
                        <div className='ExtRangeLeftQItem'>INTEGRITY</div>
                        <div className='ExtRangeLeftQItem'>PROFESSIONALISM</div>
                        <div className='ExtRangeLeftQItem'>TRANSPARENCY</div>
                    </div> */}
                </div>

                <div className='ExtRangeRightCont'>
                    <img className='ExtRangeRightImg' src={RightImg} alt="" />

                </div>
            </div>

        </div>
    )
}

export default ExtensiveRange